const available_countries_options = [
  { label: 'HU', value: 'HU' },
  { label: 'RO', value: 'RO' },
  { label: 'BG', value: 'BG' },
  { label: 'BE', value: 'BE' },
  { label: 'SK', value: 'SK' },
  { label: 'NL', value: 'NL' },
  { label: 'SE', value: 'SE' },
  { label: 'IT', value: 'IT' },
  { label: 'ES', value: 'ES' },
  { label: 'FR', value: 'FR' },
  { label: 'CZ', value: 'CZ' },
  { label: 'GB', value: 'GB' },
  { label: 'DE', value: 'DE' },
  { label: 'PL', value: 'PL' },
]

export default available_countries_options
